import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping } from '@fortawesome/free-solid-svg-icons';
import type { EmptyStateBoxProps } from './types';
import { EmptyStateBox as StyledEmptyStateBox, EmptyStateText, EmptyStateIconWrap } from './styles';

const EmptyStateBox: React.FC<EmptyStateBoxProps> = ({ message = 'No orders found' }) => (
  <StyledEmptyStateBox>
    <EmptyStateIconWrap>
      <FontAwesomeIcon icon={faBagShopping} fontSize={50} />
    </EmptyStateIconWrap>
    <EmptyStateText>{message}</EmptyStateText>
  </StyledEmptyStateBox>
);

export default React.memo(EmptyStateBox);
